import { posthog } from 'posthog-js'
import getTrackingParams from 'src/utils/getTrackingParams'
import { CALENDAR_USER_ACTIONS } from '@customTypes/AppointmentCalendarUserActions'

const logUserInteraction = (direction: string, actionType: CALENDAR_USER_ACTIONS): void => {
    const utm_medium = getTrackingParams(window.location)['utm_medium']

    if (actionType === CALENDAR_USER_ACTIONS.FINGER_SWIPE) {
      posthog.capture(`User swiped ${direction}`, { utm_medium: utm_medium })
    }

    if (actionType === CALENDAR_USER_ACTIONS.ARROW_CLICK) {
      posthog.capture(`User clicked ${direction}`, { utm_medium: utm_medium })
    }

}

export default logUserInteraction
